<div class="container">
    <div class="one-comment" *ngFor="let item of comments">
        <div class="comment-head">
            <div class="head-left">
                <div class="head-img" [style.background-color]="getBackgroundColorById(item.submitter.id)">
                    {{getAbbrName(item.submitter)}}
                </div>
                <div class="head-name text-ellipise" [title]="item.submitter.name"
                    (click)="onClickUser($event,item.submitter)">
                    {{item.submitter.name}}
                </div>
            </div>
            <div class="head-right">
                {{item.submittedDate|date:'dd-MMM-yyyy HH:mm'}}
            </div>
        </div>
        <div class="comment-body">{{item.comment}}</div>
    </div>
</div>